(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60826],{

/***/ 36098:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/b2b",
      function () {
        return __webpack_require__(96949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ SeveralBrandsCategoryPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/layouts/severalBrandsWrapper.tsx + 9 modules
var severalBrandsWrapper = __webpack_require__(73191);
// EXTERNAL MODULE: ./src/components/severalbrands/HeroSection/index.tsx
var HeroSection = __webpack_require__(53276);
// EXTERNAL MODULE: ./src/components/severalbrands/metaTags/index.tsx
var metaTags = __webpack_require__(66405);
// EXTERNAL MODULE: ./src/components/severalbrands/utils/index.ts
var utils = __webpack_require__(54531);
// EXTERNAL MODULE: ./src/components/severalbrands/logoSlider/index.tsx
var logoSlider = __webpack_require__(93549);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/secondSection/index.tsx + 1 modules
var secondSection = __webpack_require__(63305);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/thirdSection/index.tsx + 1 modules
var thirdSection = __webpack_require__(88023);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/forthSectionContainer/style.module.scss
var style_module = __webpack_require__(54657);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/forthSection/index.tsx + 1 modules
var forthSection = __webpack_require__(4130);
;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/forthSectionContainer/index.tsx



const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Our Expertise",
        paragraphs: [
            "Our digital marketing solutions connect your B2B offerings with clients who are looking for them, using the strategies outlined below.",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold 3xl:text-3xl lg:text-xl 3xl:leading-[4rem] text-base lg:leading-10 text-[#351C4F]",
                        children: "Search Engine Marketing (SEM):"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Our SEM strategies combine paid search and organic techniques to maximize your visibility. By managing PPC campaigns and optimizing landing pages, we drive high-intent traffic to your B2B solutions, delivering real value for your spend."
                    })
                ]
            }), 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px]  lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Search Engine Optimization (SEO):",
        paragraphs: [
            "Our SEO strategies help your B2B solutions rank well on search engines, so potential clients can find you. By targeting industry-specific keywords and optimizing our comparison and review sites, we drive organic traffic and visibility to your site.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: `${(style_module_default()).mainTitleStyle} 3xl:mt-16`,
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]   "
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Content Marketing",
        paragraphs: [
            "We create informative content that addresses your target audience's actual pain points, building the trust and credibility that helps potential clients choose your solutions.",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold 3xl:text-3xl lg:text-xl 3xl:leading-[4rem] text-base lg:leading-10 text-[#351C4F] ",
                        children: "Social Media Campaigns:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Our social media strategies meet audiences on the platforms where they already spend time, highlighting what makes your B2B solutions worth choosing."
                    })
                ]
            }), 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        mainTitleClassName: (style_module_default()).mainTitleStyle,
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28  3xl:mt-8 lg:mt-5"
    },
    {
        img: "/severalbrands/assets/images/unlockingBusinessComponentImg4.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "Our display campaigns use data-driven targeting and strong creative to put your B2B solutions in front of the right audience, building recognition and driving conversions.",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold 3xl:text-3xl lg:text-xl 3xl:leading-[4rem] text-base lg:leading-10 text-[#351C4F] ",
                        children: "Localization:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "We tailor your marketing to resonate with local markets, adapting content and messaging to regional preferences so you connect with clients across different geographies."
                    })
                ]
            }), 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28`,
        mainTitleClassName: (style_module_default()).mainTitleStyle,
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]  lg:mt-20"
    }, 
];
const partnerWithUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "At Several Brands, we're invested in your growth, not just handing off leads and moving on. Our team builds and adjusts campaigns around your KPIs, backed by lead validation that combines automated checks with human review, so what reaches you has already been screened. From lead generation to reporting, we handle the process so your team can focus on closing.",
            className: "default"
        }, 
    ],
    buttonText: "Talk to Our Sales Team"
};
function ForthSectionContainer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(forthSection/* default */.Z, {
        mainData: {
            partnerWithUSData: partnerWithUSData,
            unlockBusinessContent: unlockBusinessContent
        }
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/b2b/secondSection/strategicLeadGeneration/icons/b2bLeadCultivationIcon.tsx
var b2bLeadCultivationIcon = __webpack_require__(69508);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerCallIcon.tsx
var costPerCallIcon = __webpack_require__(73760);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerClickIcon.tsx
var costPerClickIcon = __webpack_require__(59591);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerLeadIcon.tsx
var costPerLeadIcon = __webpack_require__(587);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerRetainerIcon.tsx
var costPerRetainerIcon = __webpack_require__(59535);
;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/b2bGeneralContainer/index.tsx







// Main general category shared components


// specific category components

// images and icons





// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/torts.webp",
    mainTitle: "Get Results with Performance-Based Lead Generation",
    paragraphs: [
        "We go beyond SEM, SEO, and digital ads, layering in content marketing, social media strategy, and email campaigns tailored to your business. Our performance-based model means you only pay for the results we deliver, no leads, no cost, so your investment ties directly to outcomes you can measure. Pricing is built around what fits your goals, whether that's leads, calls, or sales, and with fast onboarding, you can typically start receiving leads within 48 to 72 hours of signing.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our approach to B2B lead generation is built on identifying genuine buyer intent and connecting it to the right sales opportunity.",
    bottomDescription: "Outsourcing your lead generation is a cost-effective way to grow without stretching your internal team thin. Partnering with us means you can focus on your product and your clients, while we handle sourcing and delivering leads that fit your criteria.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "We focus on identifying and cultivating genuine B2B buying intent, so the leads we deliver are engaged and ready for your team to follow up on, meaning fewer wasted conversations and more opportunities that convert. We've worked across a wide range of industries, helping companies that serve other businesses grow their pipeline.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2bLeadCultivationIcon/* default */.Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click (CPC)",
            p: "Ideal for building exposure and testing new audiences. You only pay when someone clicks, so you can gauge interest before committing further.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerClickIcon/* default */.Z, {})
        },
        {
            title: "Cost Per Lead (CPL)",
            p: "Our primary model for B2B. You pay only when a prospect takes a measurable action, like submitting a form, so your spend follows real buyer intent.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerLeadIcon/* default */.Z, {})
        },
        {
            title: "Cost Per Call",
            p: "Built for businesses where phone conversations drive revenue. You pay only for calls that meet an agreed duration or result in a real conversation.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerCallIcon/* default */.Z, {})
        },
        {
            title: "Custom & Blended Models",
            p: "Every business is different. If CPC, CPL, or cost-per-call doesn't fit your goals exactly, we'll build a model around what matters most to your pipeline.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerRetainerIcon/* default */.Z, {})
        }, 
    ],
    benefitListClassName: "lg:max-w-[1500px] lg:mx-auto",
    benefitItemClassName: "lg:!w-[480px] 3xl:!w-[580px]"
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "We work with your business to build a pricing strategy that aligns with your performance goals and requirements."
        },
        {
            description: "We research your ideal customer profile (ICP) and build targeted campaigns designed to reach real prospects and maximize conversions."
        },
        {
            description: "Every lead goes through our verification system, which filters out fraud, checks syntax, and flags duplicates, as well as a human review, before it's sent to you. We use keyword optimization and strategic timing throughout to support stronger conversion rates."
        },
        {
            description: "You share regular performance reports on lead contact status and conversion outcomes, which helps us refine targeting and improve lead quality over time."
        },
        {
            description: "Together, we agree on KPIs for cost per sale or opportunity, and adjust payouts based on performance against those benchmarks."
        },
        {
            description: "We repeat steps 2 through 4, refining continuously, until we reach an autopilot mode that consistently meets our shared KPIs."
        }, 
    ]
};
function B2bGeneralContainer() {
    const { domain , category  } = (0,useDomainContext/* useDomainContext */.w)();
    const finalLogos = (0,utils/* getFinalLogosForLogoSLider */.fH)(domain.config?.sliderLogos, category?.slug);
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(metaTags/* default */.Z, {
                title: category?.title ?? "B2B Lead Generation Services | SeveralBrands.com",
                description: description ?? "See how our B2B lead generation strategies can strengthen your sales funnel. Schedule a call today.",
                keyWords: (0,utils/* getKeyWordsForMetaTags */.U8)(domain)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {}),
            finalLogos?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(logoSlider/* default */.Z, {
                logos: finalLogos,
                mainTitle: "We Collaborate With Hundreds of Companies in Different Sectors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(secondSection/* default */.Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(thirdSection/* default */.Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForthSectionContainer, {})
        ]
    });
}

;// CONCATENATED MODULE: ./pages/severalbrands/b2b/index.tsx




var __N_SSP = true;
function SeveralBrandsCategoryPage() {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(severalBrandsWrapper/* default */.Z, {
        domainInfo: domain,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bGeneralContainer, {})
    });
}


/***/ }),

/***/ 93549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LogoSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76265);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71391);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81467);






function LogoSlider({ logos , animationDuration , showButton , mainTitle , buttonText  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: removeAnimationStyle , 1: setRemoveAnimationStyle  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useAnimation */ ._)();
    const finalLogos = logos;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const startAnimation = window.innerWidth < 767 ? finalLogos.length > 2 : finalLogos.length > 6;
        if (startAnimation) {
            setRemoveAnimationStyle(false);
            const mainScrolled = document.getElementById("mainSectionDevRef");
            if (mainScrolled) {
                mainScrolled.setAttribute("data-animated", "true");
            }
            const innerScrolled = document.getElementById("innerSectionDevRef");
            if (innerScrolled) {
                const innerScrolledContent = Array.from(innerScrolled.children);
                innerScrolledContent.forEach((item)=>{
                    const duplicatedItem = item.cloneNode(true);
                    innerScrolled.appendChild(duplicatedItem);
                });
            }
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    const outerSectionStyle = {
        "--animationDuration": `${animationDuration ? animationDuration : 40}s`
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        id: "mainSectionDevRef",
        className: ` 3xl:mt-36 lg:mt-32 mt-24    relative  mx-auto ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrolled)}`,
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        style: outerSectionStyle,
        children: [
            !removeAnimationStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:block absolute inset-0 z-20 before:absolute before:left-0 before:top-0 before:w-1/4 before:h-full before:bg-gradient-to-r before:from-white before:to-transparent before:filter before:blur-3 after:absolute after:right-0 after:top-0 after:w-1/4 after:h-full after:bg-gradient-to-l after:from-white after:to-transparent after:filter after:blur-3"
            }) //the shadow on both sides on the slider
            ,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "relative z-30 font-bold 3xl:text-6xl lg:text-4xl text-2xl lg:leading-10 text-center ",
                children: mainTitle || "We Collaborate With 600+ Companies in Different Sectors"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "innerSectionDevRef",
                className: `mt-7 lg:mt-12  3xl:mt-20  3xl:h-[60px] lg:h-[45px] h-[29px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrolled__inner)} ${removeAnimationStyle ? "justify-center" : ""}`,
                children: finalLogos?.map((logo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `w-[120px]  lg:w-[172px] 3xl:w-[250px] relative `,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative mx-auto w-[80%] h-[100%] block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: logo.path,
                                alt: logo.slug,
                                layout: "fill",
                                objectFit: "contain",
                                loading: "eager"
                            })
                        })
                    }, index))
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "z-30 relative 3xl:mt-20 mt-12 text-center w-fit mx-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: buttonText || "Partner With Us"
                })
            })
        ]
    });
}


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ }),

/***/ 54657:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainTitleStyle":"style_mainTitleStyle__WlyHe"};

/***/ }),

/***/ 71391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","scrolled":"style_scrolled__fS6VT","scrolled__inner":"style_scrolled__inner__gigDt","scroll":"style_scroll__sLdOC"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,83831,81711,73921,49774,92888,40179], function() { return __webpack_exec__(36098); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);